import { apiConfig } from '@/services/api-config';

export default async function (tokenKey: string, cdTerritory: string) {
  return apiConfig
    .get(`api/ActDocument/get-by-cdTerritory?cdTerritory=${cdTerritory}&tokenKey=${tokenKey}`)
    .then((response) => response.data)
    .catch(() => []);
}
